<template>
    <div class="h-full w-full">
        <div class="mx-auto container p-4">
            <Loading :loading="loading" class="min-h-screen">
                <!-- Toolbar -->
                <div v-if="!loading" class="flex flex-wrap gap-4 justify-end items-center">
                    <!-- filter -->
                    <div v-click-outside="() => (filterOpened = false)">
                        <div
                            @click="filterOpened = !filterOpened"
                            class="flex flex-row gap-2 cursor-pointer p-2"
                            :class="selected_product_ids.length > 0 || published_at ? 'bg-blue rounded-md text-white' : ''"
                        >
                            <Icon type="Filter" class="fill-current" viewBox="0 0 21 20" width="21" height="20" />
                            <p>{{ $t('plain_filter') }}</p>
                        </div>
                        <TransitionExpand v-show="filterOpened" class="absolute top-12 right-0 z-[60] w-full lg:w-[600px]">
                            <div class="rounded-md shadow-md p-4 bg-white">
                                <div class="flex flex-col lg:flex-row gap-4">
                                    <div class="w-full lg:h-[286px] overflow-y-scroll" v-if="Object.keys(products).length > 1">
                                        <p class="mb-4">{{ $t('Filter Markets') }}</p>
                                        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-x-4">
                                            <div v-for="(name, id) in products" :key="id">
                                                <Checkbox
                                                    :name="$translate(name)"
                                                    :label="$translate(name)"
                                                    @update:value="selectProductID(id)"
                                                    :value="selected_product_ids.includes(id)"
                                                    class="my-1"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <Datepicker
                                        :modelValue="published_at"
                                        @update:modelValue="selectPublishedAt"
                                        :model-type="calendarModeltype"
                                        class="!m-0"
                                        :class="products ? 'w-full z-50 relative' : 'w-1/2 lg:w-full z-50 relative'"
                                        :locale="calendarLocale"
                                        :selectText="$t('plain_select')"
                                        :enableTimePicker="false"
                                        :range="true"
                                        inline
                                        autoApply
                                        :monday-first="true"
                                    />
                                </div>
                                <hr class="border-gray-500 w-full mt-2 mb-4" />
                                <div class="flex flex-row gap-2 justify-between">
                                    <p @click="reset()" class="text-blue cursor-pointer">{{ $t('plain_reset') }}</p>
                                    <p @click="search()" class="text-blue cursor-pointer">{{ $t('plain_apply') }}</p>
                                </div>
                            </div>
                        </TransitionExpand>
                    </div>
                    <!-- filter end -->
                </div>

                <!-- tab contentstreams type -->
                <Tabs
                    v-if="!loading"
                    v-model:data="tabs"
                    activeColor="#000000"
                    v-model:activeTab="activeTab"
                    :overlay="false"
                    align="start"
                    :firstOnLoad="false"
                    class="pt-4"
                    @update:activeTab="changeTab"
                >
                    <template #header="{ data }">
                        <strong>
                            {{ $translate(data.title) }}
                        </strong>
                    </template>
                    <!-- single contentstreams block -->
                    <template #item="{ data }">
                        <Loading :loading="innerLoading" class="w-full min-h-12">
                            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4" v-if="!innerLoading">
                                <SingleVideoAnalysis
                                    v-for="contentstream in $store.getters['contentstreams/getByKey'](data.id).data"
                                    :key="contentstream.id"
                                    :data="contentstream"
                                    :page="page"
                                    :active_tab="active_tab"
                                    :query_params="query_params"
                                />
                            </div>
                            <p v-if="$store.getters['contentstreams/getByKey'](data.id)?.data?.length <= 0">
                                {{ $t('No Data') }}
                            </p>
                            <!-- Pager -->
                            <div v-if="!innerLoading" class="flex justify-end mt-10">
                                <Pagination :limit="3" :data="$store.getters['contentstreams/getByKey'](data.id)" @pagination-change-page="selectTab" />
                            </div>
                        </Loading>
                    </template>
                </Tabs>
            </Loading>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../api';
import SingleVideoAnalysis from './SingleVideoAnalysis.vue';
import _ from 'lodash';

export default {
    mounted() {
        this.loading = true;
        this.getAvailableProducts();
        this.replaceQueryParams({ type: 'videoanalysis' });
        // initially set data from query
        this.active_tab = this.$route?.query?.active_tab || 'webinar';
        this.published_at = this.$route?.query?.published_at?.split(',') || null;
        this.selected_product_ids = this.$route?.query?.selected_product_ids?.split(',') || [];
        this.page = this.$route?.query?.page || 1;
        this.$store.dispatch('contentstream_types/index').then((contentstream_types) => {
            // this.special = contentstream_types.data.find(contentstream_type => contentstream_type.name === 'special')
            // this.short = contentstream_types.data.find(contentstream_type => contentstream_type.name === 'short')
            // this.dmu = contentstream_types.data.find(contentstream_type => contentstream_type.name === 'dmu')
            // this.dsu = contentstream_types.data.find(contentstream_type => contentstream_type.name === 'dsu')
            // this.wmu = contentstream_types.data.find(contentstream_type => contentstream_type.name === 'wmu')
            this.webinar = contentstream_types.data.find((contentstream_type) => contentstream_type.name === 'webinar');
            this.activeTab = this.tabs.find((tab) => tab.id === this.active_tab);
            this.loading = false;
            this.$nextTick(() => {
                this.selectTab(this.page);
            });
        });
    },
    methods: {
        // reset filter
        reset() {
            this.filterOpened = false;
            this.published_at = null;
            this.selected_product_ids = [];
            this.replaceQueryParams({ published_at: '' });
            this.replaceQueryParams({ selected_product_ids: '' });
            this.indexContentstreams();
        },
        // filter search (anwenden)
        search() {
            this.filterOpened = false;
            this.indexContentstreams();
        },
        async indexContentstreams(params) {
            this.innerLoading = true;

            let published_at_formatted = null;

            if (this.published_at) {
                if (this.published_at[0] && this.published_at[1]) {
                    published_at_formatted = [];
                    published_at_formatted[0] = new Date(this.$moment(this.published_at[0]).startOf('day'));
                    published_at_formatted[1] = new Date(this.$moment(this.published_at[1]).endOf('day'));
                } else if (this.published_at[0]) {
                    published_at_formatted = [];
                    published_at_formatted[0] = new Date(this.$moment(this.published_at[0]).startOf('day'));
                    published_at_formatted[1] = new Date(this.$moment(this.published_at[0]).endOf('day'));
                }
            }

            let config = {
                params: {
                    'sort[by]': 'published_at',
                    'sort[order]': 'desc',
                    key: this.active_tab || 'webinar',
                    active_tab: this.active_tab || 'webinar',
                    page: this.page || 1,
                    product_id: this.selected_product_ids || null,
                    published_at: published_at_formatted,
                    contentstream_type_id: this.contentstream_type_id
                }
            };
            _.merge(config.params, params);
            return await this.$store.dispatch('contentstreams/index', config).then(() => {
                this.innerLoading = false;
            });
        },
        // Available products for customer
        async getAvailableProducts() {
            await api.get('/api/v1/contentstreams/filters').then((response) => {
                this.products = {};
                let productsRaw = response.data.products_only_webinars;
                let sortedIds = Object.keys(productsRaw).sort((a, b) => productsRaw[a].localeCompare(productsRaw[b]));

                sortedIds.forEach((element) => {
                    this.products[element] = productsRaw[element];
                });
            });
        },
        // filter products
        selectProductID(product_id) {
            if (this.selected_product_ids.includes(product_id)) {
                this.selected_product_ids.splice(this.selected_product_ids.indexOf(product_id), 1);
                this.replaceQueryParams({ selected_product_ids: this.selected_product_ids, page: 1 });
            } else {
                this.selected_product_ids.push(product_id);
                this.replaceQueryParams({ selected_product_ids: this.selected_product_ids, page: 1 });
            }
            // update query accordingly
            if (this.selected_product_ids.length <= 0) {
                this.replaceQueryParams({ selected_product_ids: '' });
            }
            this.indexContentstreams();
        },
        // filter set date
        selectPublishedAt(published_at) {
            if (published_at) {
                this.published_at = [published_at[0], published_at[1]];
            } else {
                this.published_at = null;
            }
            // update query accordingly
            if (this.published_at) {
                this.replaceQueryParams({
                    published_at: this.published_at,
                    page: 1
                });
                this.page = 1;
            } else {
                this.replaceQueryParams({ published_at: '' });
            }
            this.indexContentstreams();
        },
        // contentstream type Tab
        selectTab(page = 1) {
            this.page = page;
            this.contentstream_type_id = [this.webinar.id];
            this.active_tab = this.activeTab.id;
            this.replaceQueryParams({
                page: this.page,
                active_tab: this.activeTab?.id
            });
            this.indexContentstreams();
        },
        // reset page to first page if tab is going to change
        changeTab() {
            this.selectTab(1);
        }
    },
    computed: {
        query_params() {
            let params = {};
            this.active_tab ? (params['active_tab'] = this.active_tab) : (params['active_tab'] = 'webinar');
            this.published_at ? (params['published_at'] = this.published_at) : '';
            this.selected_product_ids?.length > 0 ? (params['selected_product_ids'] = this.selected_product_ids) : '';
            this.page ? (params['page'] = this.page) : (params['page'] = 1);
            params['type'] = 'videoanalysis';
            let combinedParams = new URLSearchParams(params);
            return combinedParams;
        },
        ...mapGetters('contentstreams', {
            getByKey: 'getByKey'
        }),
        region() {
            return window.meta.region_configuration.region || 'de';
        },
        calendarLocale() {
            return this.region === 'de' ? 'de-DE' : 'en-GB';
        },
        calendarModeltype() {
            return this.region === 'de' ? 'dd.mm.yyyy' : 'yyyy-mm-dd';
        }
    },
    data: () => ({
        tabs: [
            // {
            //     title: "Meine Analysen",
            //     id: "webinar",
            //     items: []
            // },
            // {
            //     title: "Kurznachrichten",
            //     id: "short",
            //     items: []
            // },
            // {
            //     title: "Sondernachrichten",
            //     id: "special",
            //     items: []
            // },
            {
                title: 'Videoanalysen',
                id: 'webinar',
                items: []
            }
        ],
        activeTab: null,
        short: null,
        dmu: null,
        wmu: null,
        special: null,
        webinar: null,
        loading: true,
        innerLoading: false,
        filterOpened: false,
        published_at: null,
        selected_product_ids: [],
        products: [],
        contentstream_type_id: null,
        page: 1,
        active_tab: null
    }),
    components: { SingleVideoAnalysis }
};
</script>
